/*
  SPDX-License-Identifier: SEE LICENSE IN EULA.md
  SPDX-FileCopyrightText: 2020-2026 CYBERTEC PostgreSQL International GmbH <office@cybertec.at>
*/
export const currency = ({
  language = 'en',
  value,
  currency,
}: {
  value: number;
  currency: string;
  language?: string;
}) =>
  value.toLocaleString(language, {
    currency: currency,
    style: 'currency',
  });

export const currencyShort = ({
  language = 'en',
  value,
  currency,
}: {
  value: number;
  currency: string;
  language?: string;
}) =>
  value.toLocaleString(language, {
    currency: currency,
    style: 'currency',
    minimumFractionDigits: 0,
    maximumFractionDigits: 2,
  });
